import React, { useEffect, useState } from 'react';
import {Box, Skeleton, Typography, Grid } from '@mui/material';
import RegionSelect from './region-select.component';
import StyledPaper from '../common/styled-paper.component';
import useAnalytics from "./../../hooks/useAnalytics";
import ProductViewDetailsDialog from "./dialog/product-view-details.dialog";
import EmptyIcon from "../../assets/images/empty-box.png";

function VerificationFrequencyRows({top_product_auth_vs_verification, setVerificationData, setOpenProductView}){

    const handleOpenProductView = (e, row) => {
        setVerificationData(row);
        setOpenProductView(true);
    }

    return (
        <>
            {
                top_product_auth_vs_verification.map((row) => (
                <Grid container sx={{background: "#f4f4fe", p: 1.5, mt: 2, mb: 2, borderRadius: '6px', textAlign: 'center', cursor: "pointer"}}
                    onClick={(e) => handleOpenProductView(e, row)}
                >
                    <Grid item xs={6}>
                        <Typography>{row.product_name}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography>{row.verificationCount}</Typography>
                    </Grid>
                </Grid>
                ))
            }
        </>
    )
}

export default function VerificationFrequenciesTable() {
  
    const {isLoadingTopProductVsVerification, error, top_product_auth_vs_verification, getTopProductAuthVsVerification } = useAnalytics();
    const [region, setRegion] = useState(null);
    const [country, setCountry] = useState(null);

    const [verificationData, setVerificationData] = useState(null);
    const [openProductView, setOpenProductView] = useState(false);

    useEffect(()=>{
        if(country == null) return;
        if(region == null) return;
        getTopProductAuthVsVerification(country, region);
    }, [region, country]);

    return (
        <>
            <StyledPaper>
                <Grid container sx={{pb: 2}}>
                    <Grid item xs={12} sm={6} lg={9}>
                        <Typography>Top Product Authentication vs their Verification Frequencies</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                        <RegionSelect onRegionChange={setRegion} onCountryChange={setCountry}/>
                    </Grid>
                </Grid>

                {isLoadingTopProductVsVerification ?
                    <Box sx={{display: "block"}}>
                        <Skeleton variant="text" sx={{backgroundColor: "#d8d8fdbd"}} height={"60px"} />
                        <Skeleton variant="text" sx={{backgroundColor: "#d8d8fdbd"}} height={"60px"} />
                        <Skeleton variant="text" sx={{backgroundColor: "#d8d8fdbd"}} height={"60px"} />
                        <Skeleton variant="text" sx={{backgroundColor: "#d8d8fdbd"}} height={"60px"} />
                        <Skeleton variant="text" sx={{backgroundColor: "#d8d8fdbd"}} height={"60px"} />
                    </Box>
                :
                    (!isLoadingTopProductVsVerification && top_product_auth_vs_verification?.length === 0) ?
                        <Box sx={{textAlign: "center", flexDirection: "column", mb: 10,
                            justifyContent: "center", display: "flex", alignItems: "center", 
                        }}>
                            <img alt="empty-data-icon" src={EmptyIcon} width="110" style={{marginTop: "72px"}} />

                            <Typography sx={{color: "#58565f", fontSize: 14, mt: 1}}>
                                No data available for the selected location
                            </Typography>
                        </Box>
                :   
                    <>
                        <Grid container sx={{background: "#dadafc", color: '#5d5ed8', p: 1.5, borderRadius: '6px', textAlign: 'center'}}>
                            <Grid item xs={6}>
                                <Typography>Product Name</Typography>
                            </Grid>

                            <Grid item xs={6}>
                                <Typography>Verification Frequency</Typography>
                            </Grid>
                        </Grid>

                        <VerificationFrequencyRows 
                            top_product_auth_vs_verification={top_product_auth_vs_verification} 
                            setOpenProductView={setOpenProductView}
                            setVerificationData={setVerificationData} 
                        />
                    </>
                }
                
            </StyledPaper>

            {openProductView &&
                <ProductViewDetailsDialog 
                    openProductView={openProductView} 
                    setOpenProductView={setOpenProductView} 
                    verificationData={verificationData}
                />
            }
        </>
  ) ;
}